import { apiClient } from "api/trpc/trpc-client"
import { appendUlidToFile } from "./file-operations"
import { FileUploadResult } from "reusable/mui/file-uploads/FileUploadMultiple"

interface UploadFileType {
   orgId: string,
}

interface RichTextEditorType extends UploadFileType {
   type: 'RichTextEditor'
}

interface DocFileUploadType extends UploadFileType {
   workItemId: string,
   workItemBlockId: string,
   docId: string,
   type: 'DocFile'
}

type UploadFileOptions = RichTextEditorType | DocFileUploadType

export async function getUploadUrl(options: UploadFileOptions, file: File) {
   return await (async () => {
      switch (options.type) {
         case 'DocFile': {
            const { url } = await apiClient.docBlock.getUploadUrl.query({
               orgId: options.orgId,
               workItemId: options.workItemId,
               workItemBlockId: options.workItemBlockId,
               fileName: file.name
            })
            return url
         }
         case 'RichTextEditor': {
            const { url } = await apiClient.content.getImageUploadUrl.query(
               {
                  fileName: file.name,
               }
            )
            return url
         }
      }
   })()
}

export async function uploadFile(options: UploadFileOptions, originalFile: File): Promise<FileUploadResult> {
   // Ensure the file we want to upload has a unique file name
   const file = appendUlidToFile(originalFile)

   // Get the upload url for the file we want to upload
   const fileUploadUrl = await getUploadUrl(options, file)

   if (!fileUploadUrl) {
      // In case something goes wrong in the api
      throw new Error('Error communicating with the server')
   }
   await fetch(fileUploadUrl, {
      method: 'PUT',
      body: file,
      headers: { 'Content-Type': 'multipart/form-data' },
   })

   return {
      uploadUrl: fileUploadUrl,
      originalFileName: originalFile.name,
      fileName: file.name
   }
}